export default __webpack_public_path__ + "static/media/engineering.1595a023.png";